import React from 'react';
import { PackageIcon, UsersIcon, MapIcon, SofaIcon, BuildingIcon, HomeIcon, GlobeIcon } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    icon: PackageIcon,
    title: 'Emergency Parcel & Item Delivery',
    description: 'When time is critical, our emergency delivery service ensures fast and secure transportation of parcels and items anywhere in the UK.'
  }, {
    icon: UsersIcon,
    title: 'Contract Delivery Driver Supply',
    description: 'We provide professional contractor delivery drivers to businesses requiring short-term or long-term logistics support.'
  }, {
    icon: MapIcon,
    title: 'Nationwide Delivery Coverage',
    description: 'Our nationwide delivery network allows us to reach any location in the UK quickly and efficiently.'
  }, {
    icon: SofaIcon,
    title: 'Furniture Delivery & Assembly',
    description: 'Our team offers furniture delivery and build services for homes, offices, and commercial environments.'
  }, {
    icon: BuildingIcon,
    title: 'Office Relocation Services',
    description: 'We specialise in efficient office relocations, ensuring business equipment and furniture are transported safely.'
  }, {
    icon: HomeIcon,
    title: 'House Relocation Services',
    description: 'Moving home? Our relocation specialists manage the transport and logistics to make your move stress-free.'
  }, {
    icon: GlobeIcon,
    title: 'International Migration Support',
    description: 'We assist with international relocation logistics, helping customers move and settle into new locations smoothly.'
  }];
  return <section className="py-20 bg-white" data-id="element-156">
      <div className="container mx-auto px-4" data-id="element-157">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-158">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-159">
            Our Services
          </h2>
          <p className="text-lg text-slate-600" data-id="element-160">
            Comprehensive logistics and delivery solutions tailored to your
            specific needs, available across the UK.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-161">
          {services.map((service, index) => {
          const Icon = service.icon;
          const isFeatured = index === 0;
          return <div key={index} className={`group rounded-2xl border p-8 transition-all duration-300 relative overflow-hidden ${isFeatured ? 'bg-primary border-primary text-white shadow-xl lg:col-span-2 lg:flex lg:items-center lg:gap-8' : 'bg-white border-slate-200 hover:border-primary hover:shadow-xl'}`} data-id="element-162">
                {isFeatured && <div className="absolute top-0 right-0 bg-red-600 text-white text-xs font-bold px-4 py-1 rounded-bl-lg z-10" data-id="element-163">
                    OUR SPECIALITY
                  </div>}

                <div className={`h-14 w-14 rounded-xl flex items-center justify-center mb-6 shrink-0 ${isFeatured ? 'bg-white/20 text-white' : 'bg-blue-50 group-hover:bg-primary group-hover:text-white transition-colors'}`} data-id="element-164">
                  <Icon className={`h-7 w-7 ${isFeatured ? 'text-white' : 'text-primary group-hover:text-white transition-colors'}`} data-id="element-165" />
                </div>

                <div data-id="element-166">
                  <h3 className={`text-xl font-bold mb-3 ${isFeatured ? 'text-white text-2xl' : 'text-slate-900'}`} data-id="element-167">
                    {service.title}
                  </h3>
                  <p className={`leading-relaxed ${isFeatured ? 'text-blue-100 text-lg' : 'text-slate-600'}`} data-id="element-168">
                    {service.description}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}